import React from "react";

class EmotionLine extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleEmotionChange = this.handleEmotionChange.bind(this);
        this.handleIntensityChange = this.handleIntensityChange.bind(this);
        this.handleSentimentChange = this.handleSentimentChange.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }


    update(changes)
    {
        const item = {
            ...this.props.item,
            ...changes
        };

        if (this.props.onChange)
            this.props.onChange(item);
    }


    handleEmotionChange(event)
    {
        
        this.update({
            type: event.target.value
        });
    }


    handleIntensityChange(event)
    {
        this.update({
            intensity: parseFloat(event.target.value)
        });
    }


    handleSentimentChange(event)
    {
        this.update({
            sentiment: parseFloat(event.target.value)
        });
    }


    handleDelete()
    {
        if (this.props.onDelete)
            this.props.onDelete();
    }


    render()
    {
        const item = this.props.item;
        const emotionsList = this.props.emotionsList || [];

        const intensityLimit =
            this.props.intensityLimit || {
                min: -0.5,
                max: 0.5
            };

        const sentimentLimit =
            this.props.sentimentLimit || {
                min: -0.5,
                max: 0.5
            };

        const image =
            item.source === "HUMAN"
                ? this.props.imgHuman
                : this.props.imgIA;


        return (
            <div className="emotion-line">

                {/* Image */}
                <div className="emotion-line-image">
                    {image && (
                        <img
                            src={image}
                            alt=""
                        />
                    )}
                </div>


                {/* Emotion */}
                <div className="emotion-line-emotion">
                    <select
                        value={item.type}
                        onChange={this.handleEmotionChange}
                    >
                        {emotionsList.map((emotion) => (
                            <option
                                key={emotion.emotion}
                                value={emotion.emotion}
                            >
                                {emotion.text}
                            </option>
                        ))}
                    </select>
                </div>


                {/* Intensité */}
                <div className="emotion-line-value">
                    <input
                        type="range"
                        min={intensityLimit.min}
                        max={intensityLimit.max}
                        step="0.1"
                        value={item.intensity}
                        onChange={this.handleIntensityChange}
                    />

                    <span>
                        {Number(item.intensity).toFixed(1)}
                    </span>
                </div>


                {/* Sentiment */}
                <div className="emotion-line-value">
                    <input
                        type="range"
                        min={sentimentLimit.min}
                        max={sentimentLimit.max}
                        step="0.1"
                        value={item.sentiment}
                        onChange={this.handleSentimentChange}
                    />

                    <span>
                        {Number(item.sentiment).toFixed(1)}
                    </span>
                </div>


                {/* Confiance */}
                <div className="emotion-line-confidence">
                    {Number(item.confidence).toFixed(1)}
                </div>


                {/* Suppression */}
                <button
                    type="button"
                    className="emotion-line-delete"
                    onClick={this.handleDelete}
                    title="Supprimer"
                >
                    ×
                </button>

            </div>
        );
    }
}


export default EmotionLine;